module.exports = __webpack_public_path__ + "img/points_spent.212507c1.png";